import {getSeatsSourceLayer, mapIdsToValueStyle} from '../helper-functions/mapbox_helpers';
import {
  COLOR_UNAVAILABLE_SEAT,
  COLOR_AVAILABLE_SEAT,
  COLOR_SELECTED_SEAT,
  LAYER_SEATS_SOURCE,
  LAYER_SEATS_HIGHLIGHTED_ID,
} from '../mapbox-constants/mapbox_constants';

function LayerSeats(seatsConfig, venueConfigId, seatIds, selectedSeatIds) {
  return {
    id: LAYER_SEATS_HIGHLIGHTED_ID,
    type: 'circle',
    source: LAYER_SEATS_SOURCE,
    'source-layer': getSeatsSourceLayer(venueConfigId),
    minzoom: seatsConfig.ZOOM_MIN_SEATS,
    paint: {
      'circle-color': seatsCircleColor(seatIds, selectedSeatIds),
      'circle-radius': {
        stops: seatsConfig.STOP_SEATS,
      },
    },
  };
}

function seatsCircleColor(seatIds, selectedSeatIds) {
  let selectedSeatsStyle = [];
  let circleColor;
  let availableSeatsStyle;
  if (Array.isArray(seatIds) && seatIds.length > 0) {
    availableSeatsStyle = mapIdsToValueStyle(seatIds, COLOR_AVAILABLE_SEAT);

    if (Array.isArray(selectedSeatIds) && selectedSeatIds.length > 0) {
      selectedSeatsStyle = mapIdsToValueStyle(selectedSeatIds, COLOR_SELECTED_SEAT);
      circleColor = [
        'match',
        ['get', 'usid'],
        ...selectedSeatsStyle,
        ['match', ['get', 'usid'], ...availableSeatsStyle, COLOR_UNAVAILABLE_SEAT],
      ];
    } else if (availableSeatsStyle.length > 0) {
      circleColor = ['match', ['get', 'usid'], ...availableSeatsStyle, COLOR_UNAVAILABLE_SEAT];
    }
  }

  return circleColor || COLOR_UNAVAILABLE_SEAT;
}

export {seatsCircleColor};

export default {
  LayerSeats,
  LayerSeatsHighlight: LayerSeats,
  seatsCircleColor,
};
